
import { Component, Vue } from "vue-property-decorator";
import graph from "@/graph";
import { CognitoListUser, CognitoListUserPool, CognitoGetUser } from "@/graph/aws/cognito";
import ebiEditbar from "@/components/editbar/ebiEditbar.vue";
import { EventBus } from "@/events/event-bus";

@Component({
	components: {
		ebiEditbar,
	},
})
export default class UsersList extends Vue
{
	currentPool: string | null = null;
	userPoolsLoading = true;
	userPools: CognitoListUserPool[] = [];

	poolDataLoading = false;
	poolData: CognitoListUser[] = [];

	userDataLoading = false;
	userData: CognitoGetUser = {username: "", created: "", status: "", enabled: false, attributes: []};

    search = '';

	showEditbar = false;
	showAddDialog = false;
	showTempPWDialog = false;
	creatingUser = false;
	editbarTitle = "";
	tempPW = "";
	tempPWLoading = false;

	addUserForm = {
		username: "",
		email: "",
		pool: "",
		userkey: "",
	};

	handleEdit(index: number, row: CognitoListUser)
	{
		console.log(index, row);

		this.getUser(row.username);
		
	}

  async handleDelete(index: number, row: CognitoListUser)
	{
    const result = await graph.aws.cognito.deleteUser(this.currentPool, row.username);

    if (!result.success) {
      this.$notify.error(result.message);
      return;
    }

    this.$notify.success(result.message);

    await this.updateCurrentPool();
	}

	async resetPassword()
	{
		console.log("resetPassword");

		this.tempPWLoading = true;
		this.tempPW = "";

		if(this.currentPool === null || this.userData.username.length <= 0)
		{
			this.tempPWLoading = false;
			return;
		}

		const result = await graph.aws.cognito.tempPasswordForUser(this.currentPool, this.userData.username)

		console.log("resetPassword", "result:", result);

		if(result.success)
		{
			this.tempPW = result.message;
		}

		this.tempPWLoading = false;
	}

	async userEnableStatus(value: boolean)
	{
		console.log("userEnableStatus", "value:", value);

		this.userDataLoading = true;

		if(this.currentPool === null || this.userData.username.length <= 0)
		{
			this.userDataLoading = false;
			return;
		}

		const result = await graph.aws.cognito.enableUser(this.currentPool ,this.userData.username, value);

		console.log("userEnableStatus", "result:", result);

		if(!result.success)
		{
			this.userData.enabled = !value;
		}

		this.userDataLoading = false;
	}

	async createUser()
	{
		if(
			this.addUserForm.username.length <= 1 &&
			this.addUserForm.email.length <= 1 &&
			this.addUserForm.userkey.length <= 1 &&
			this.addUserForm.pool.length <= 1
		)
		{
			return;
		}

		this.creatingUser = true;

		const result = await graph.aws.cognito.createUser(this.addUserForm.pool, this.addUserForm.username, this.addUserForm.email, this.addUserForm.userkey);
		
		this.showAddDialog = false;

		if(result.success)
		{
			this.tempPW = result.message;
			this.showTempPWDialog = true;

			// reset user form
			this.addUserForm = {
				username: "",
				email: "",
				pool: "",
				userkey: "",
			};

			// query new pool user list
			this.updateCurrentPool();
		}
		else
		{
			this.$notify.error({
				title: 'User Creation Error',
				message: result.message,
			});
		}

		this.creatingUser = false;
	}

	async getUser(username: string)
	{
		this.editbarTitle = "Edit: " + username;
		this.showEditbar = true;
		this.userDataLoading = true;
		this.userData = {username: "", created: "", status: "", enabled: false, attributes: []};
		const result = await graph.aws.cognito.getUser(this.currentPool ?? "", username);
		this.userData = result ?? {username: "", created: "", status: "", enabled: false, attributes: []};
		this.userDataLoading = false;
	}

	async updateCurrentPool()
	{
		this.showEditbar = false;
		this.poolDataLoading = true;
		this.poolData = [];
		const result = await graph.aws.cognito.listUsers(this.currentPool ?? "");
		this.poolData = result;
		this.poolDataLoading = false;
	}

	async updateUserPools()
	{
		this.showEditbar = false;
		this.userPoolsLoading = true;
		const result = await graph.aws.cognito.listUserPool();
		this.userPools = result;
		this.userPoolsLoading = false;

    if (this.userPools && this.userPools.length) {
      this.currentPool = this.userPools[0].id;
    }
	}

	mounted()
	{
		this.showEditbar = false;
		this.updateUserPools();

    EventBus.$on('environment-changed', () => {
      this.updateUserPools();
    });
	}

}
